module.exports = __webpack_public_path__ + "images/5e3b8f258411d9a9596d5245b1c1a58e-cs6.jpg";